import moment from "moment";
import React from "react";
import { toast } from "react-toastify";
const HelperService = {
  getFormatedDateForDetail(dt: any, format?: any) {
    if (dt) {
      var stillUtc = moment.utc(dt).toDate();
      if (format) {
        return moment(stillUtc).local().format(format);
      } else {
        return moment(stillUtc).local().format(
          (localStorage.getItem("date_format") ?? "DD-MM-YYYY") + " hh:mm A"
        );
      }
    }
  },
  titleCase(str: any) {
    if (str !== "") {
      return str
        .toLowerCase()
        .split(" ")
        .map((word: any) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    } else {
      return str;
    }
  },
  getFormatedDate(date: any, format?: string) {
    if (date) {
      var stillUtc = moment.utc(date).toDate();
      return moment(stillUtc).local().format(format ? format : "DD-MM-YYYY hh:mm A");
    }
  },
  getUtcFormatedTime(date: any) {
    if (date) {
      var stillUtc = moment.utc(date).toDate();
      return moment(stillUtc).local().format("hh:mm A");
    }
  },
  getAPIFormatedDate(date: any) {
    if (date) {
      var stillUtc = moment.utc(date).toDate();
      return moment(stillUtc).local().format("YYYY-MM-DD");
    }
  },
  removeDialCodeFromMobile(mobileNumber: any, dialCode: any) {
    dialCode = "+" + dialCode.toString();
    if (mobileNumber.startsWith(dialCode)) {
      return mobileNumber.slice(dialCode.length);
    }
    return mobileNumber;
  },
  weeklyAvgCounter(time: any) {
    if (!time || time == 0) return "0 Minutes/Day";
    if (!isNaN(time)) {
      time = Number(time);
    }
    const hours = Math.round(time / 60);
    if (hours > 0) return hours + " Hours/Day";
    else return (`${Math.floor(time)} Minutes/Day`);
  },

  toQueryString(params: any) {
    const query = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        query.append(key, String(value));
      }
    });

    return query.toString();
  },
  isValidEmail(email: string) {
    const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.(com|in|net|org|co\.in)$/i;
    return regex.test(email);
  },
  checkFormEmptyFields(obj: any, excludedKeys: string[] = []): boolean {
    let emptyKeyFlag = false;
    const excludedKeysSet = new Set(excludedKeys);
    Object.keys(obj).forEach((key) => {
      const value = obj[key];
      if (excludedKeysSet.has(key)) return;
      if (key === "email") {
        if (!this.isValidEmail(value)) {
          emptyKeyFlag = true;
        }
      }
      if (typeof value === "boolean") {
        return;
      }
      if (value instanceof File || value instanceof Blob) {
        return;
      }
      if (value instanceof Date) {
        if (isNaN(value.getTime())) {
          emptyKeyFlag = true;
        }
        return;
      }
      const isEmptyValue =
        value === undefined ||
        value === null ||
        (typeof value === "string" && value.trim() === "") ||
        (typeof value === "object" && Object.keys(value).length === 0);

      if (isEmptyValue) {
        emptyKeyFlag = true;
      }
    });
    return emptyKeyFlag;
  },
  formatTimeTo12Hour(time24: string): string {
    if (!time24) return "";

    const [hourStr, minuteStr] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;

    return `${hour}:${minute.toString().padStart(2, "0")} ${ampm}`; // 10:00 PM
  },

  allowOnlyNumericValuesWithZero(e: React.KeyboardEvent<HTMLInputElement>) {
    const key = e.key;
    // Allow: backspace, delete, tab, escape, enter, arrows
    if (
      key === "Backspace" ||
      key === "Delete" ||
      key === "Tab" ||
      key === "Escape" ||
      key === "Enter" || key === "." ||
      (key >= "1" && key <= "9") ||
      (e.ctrlKey && (key === "a" || key === "c" || key === "v" || key === "x")) ||
      (key.startsWith("Arrow"))
    ) {
      // allow only numeric and control keys, not alpha chars
      return;
    } else {
      e.preventDefault();
    }
  },
  allowOnlyNumericValues(e: React.KeyboardEvent<HTMLInputElement>) {
  const key = e.key;
  const value = e.currentTarget.value;

  // Allow control keys
  if (
    key === "Backspace" ||
    key === "Delete" ||
    key === "Tab" ||
    key === "Escape" ||
    key === "Enter"|| key === "."  ||
    key.startsWith("Arrow") ||
    (e.ctrlKey && ["a", "c", "v", "x"].includes(key.toLowerCase()))
  ) {
    return;
  }

  // ❌ Block non-numeric
  if (!/^[0-9]$/.test(key)) {
    e.preventDefault();
    return;
  }

  // ❌ Block leading zero
  if (key === "0" && value.length === 0) {
    e.preventDefault();
  }
},
  allowOnlyAlphaNumericValues(e: React.KeyboardEvent<HTMLInputElement>) {
    const key = e.key;
    if (key === "Backspace" ||
      key === "Delete" ||
      key === "Tab" ||
      key === "Escape" ||
      key === "Enter" ||
      key === "ArrowLeft" ||
      key === "ArrowRight" ||
      key === "ArrowUp" ||
      key === "ArrowDown"
    ) {
      return;
    }

    if (e.ctrlKey || e.metaKey) {
      return;
    }
    const regex = /^[a-zA-Z0-9 ._]$/;
    if (!regex.test(key)) {
      e.preventDefault();
    }
  },

  getUnits(value: string) {
    const unitOptions = [
      { title: 'Gram', value: 'g' },
      { title: 'Kilogram', value: 'kg' },
      { title: 'Milligram', value: 'mg' },
      { title: 'Liter', value: 'l' },
      { title: 'Milliliter', value: 'ml' },
      { title: 'Cup', value: 'cup' },
      { title: 'Tablespoon', value: 'tbsp' },
      { title: 'Teaspoon', value: 'tsp' },
      { title: 'Piece', value: 'piece' },
      { title: 'Slice', value: 'slice' },
      { title: 'Bowl', value: 'bowl' },
      { title: 'Packet', value: 'packet' },
      { title: 'Bottle', value: 'bottle' },
      { title: 'Can', value: 'can' },
      { title: 'Dozen', value: 'dozen' },
      { title: 'Pint', value: 'pt' },
      { title: 'Quart', value: 'qt' },
      { title: 'Ounce', value: 'oz' }
    ];
    const found = unitOptions.find(option => option.value.toLowerCase() === value.toLowerCase());
    return found ? found.title : '';
  },
  isValidURL(url: string): boolean {
    if (!url) return false;

    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  },
  addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  },
  isValidNumberDecimal(value: string, maxDigits = 7, maxDecimals = 2) {
    const regex = new RegExp(`^\\d{0,${maxDigits}}(\\.\\d{0,${maxDecimals}})?$`);
    return regex.test(value);
  },
  fullMonthDateFormat(date: any) {
    const dt = new Date(date).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
    return this.titleCase(dt); //14 February 2026
  },
  removeUnderscores(str: string) {
    return this.titleCase(str.replace(/_/g, ' '));
  },

  truncateText(text: string, maxLength: number) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  },
  showSingleError(msg: string) {
    toast.dismiss(); // Removes all previous toasts
    toast.error(msg, {
      toastId: "single-error-toast",
      autoClose: 4000,
      delay: 100,
    });
  },
  parseTimeToMinutes(timeStr: string) {
    if (!timeStr || typeof timeStr !== "string") return NaN;

    // handle "HH:MM:SS"
    const parts = timeStr.split(":");
    if (parts.length === 3) {
      const h = parseInt(parts[0]);
      const m = parseInt(parts[1]);
      const s = parseInt(parts[2]);
      if (isNaN(h) || isNaN(m) || isNaN(s)) return NaN;

      return h * 60 + m + Math.floor(s / 60);
    }

    // handle plain minutes "20"
    const mins = Number(timeStr);
    return isNaN(mins) ? NaN : mins;
  },

  formatDateForAPI(date: Date) {
    date = new Date(date);
    const formattedDate =
      date.getFullYear() + "-" +
      String(date.getMonth() + 1).padStart(2, "0") + "-" +
      String(date.getDate()).padStart(2, "0") + "T" +
      String(date.getHours()).padStart(2, "0") + ":" +
      String(date.getMinutes()).padStart(2, "0") + ":" +
      String(date.getSeconds()).padStart(2, "0");
    return formattedDate;
  },



  isValidNumber(value: string) {
    return /^[0-9]*$/.test(value);
  },
  getRangeDays(range: any) {
    const startDate = range.startDate;
    const endDate = range.endDate;
    return (startDate && endDate) ? Math.ceil((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24) + 1) : 0;
  },

  renderStars(rating: number) {
    return (
      <div className="d-flex">
        {[1, 2, 3, 4, 5].map((star) => (
          <svg
            key={star}
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill={star <= rating ? "#F4E519" : "#E5E5E5"}
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
          </svg>
        ))}
      </div>
    );
  },
  roundUpNearestValue(value: number): number {
    if (value < 100) return Math.ceil(value / 10) * 10;
    if (value < 1000) return Math.ceil(value / 100) * 100;
    if (value < 10000) return Math.ceil(value / 1000) * 1000;
    return Math.ceil(value / 10000) * 10000;
  },

  formatCurrency(
    amount: number | string,
    // currency: 'INR' | 'USD' | 'EUR' = 'INR',
    minimumFractionDigits: number = 2,
  ): string {
    if (amount === null || amount === undefined || amount === '') {
      return '0.00';
    }
    const currency = localStorage.getItem("currency") || "INR";
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits: minimumFractionDigits,
    }).format(Number(amount));
  }
}

export default HelperService;
